"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegisterIcon = exports.getFriendlyTimeOfUseLabel = void 0;
var getFriendlyTimeOfUseLabel = function (timeOfUseLabel) {
    switch (timeOfUseLabel) {
        case 'anytime':
            return 'anytime';
        case 'peak':
            return 'peak';
        case 'offpeak':
            return 'off-peak';
        case 'solar':
            return 'solar';
        case 'interval':
            return 'smart';
        case 'eveningandweekend':
            return 'evening & weekend';
        case 'heating':
            return 'heating';
        case 'controlledload_1':
        case 'controlledload_2':
        case 'controlledload_3':
            return 'controlled load';
        case 'shoulder':
            return 'shoulder';
        default:
            return null;
    }
};
exports.getFriendlyTimeOfUseLabel = getFriendlyTimeOfUseLabel;
var getRegisterIcon = function (timeOfUseLabel) {
    switch (timeOfUseLabel) {
        case 'anytime':
            return 'meter';
        case 'peak':
            return 'peak';
        case 'offpeak':
            return 'offpeak';
        case 'solar':
            return 'solar';
        case 'interval':
            return 'interval';
        case 'eveningandweekend':
            return 'evening-and-weekend';
        case 'heating':
        case 'controlledload_1':
        case 'controlledload_2':
        case 'controlledload_3':
            return 'heating';
        default:
            return 'meter';
    }
};
exports.getRegisterIcon = getRegisterIcon;
